export default {
    eventCategory: 'lokalizacja',
    eventAction: 'start-lokalizacji',
    eventLabel: 'wariant-2',
};
